// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608131534/js/" + chunkId + "." + {"44":"85bf005e","225":"e7172eea","481":"914c1aae","486":"67071747","770":"0c7b84ea"}[chunkId] + ".0.4630072392542647.chunk.js";
};